export default "__VITE_ASSET__BHnQUIMw__"